export enum WidgetType {
  Scales,
  Coords,
  Overview,
}
